import { BaseParser, IValidateParams } from './BaseParser';
import { ValueType, ParseResult, IParseResult } from '../FormatterTypes';
import { formatterBoolParamDef } from '../Utils/ParamUtils';

const numbers = '0123456789';
const RNO = [
  '8',
  '11',
  '13',
  '16',
  '18',
  '19',
  '21',
  '23',
  '26',
  '31',
  '33',
  '35',
  '36',
  '40',
  '42',
  '44',
  '46',
  '54',
  '60',
  '63',
  '90',
  '[1-9]\\d{2}',
];
const SPECIAL = ['00', '10', '20', '7', '99'];
const ALLPREFIXES = [...RNO, ...SPECIAL];
const allPrefixesRegex = ALLPREFIXES.map(x => `(?:${x})`).join('|');
class TEDParseTelNr extends BaseParser {
  public static getInstance(): TEDParseTelNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseTelNr;

  defaultParams(): string {
    return 'AllowForeign="Y"';
  }

  getValidateParams(params: string): IValidateParams {
    const allowForeign = formatterBoolParamDef(
      'AllowForeign',
      params,
      this.defaultParams()
    );
    let separators = allowForeign ? ' -/\\.,+' : ' -/\\.,';

    return { inputsList: numbers, separators: separators };
  }

  parse(baseText: string, params: string = ''): IParseResult {
    const text = baseText.replaceAll(' ', '');
    const allowForeign = formatterBoolParamDef(
      'AllowForeign',
      params,
      this.defaultParams()
    );
    let value: ValueType = null;
    let result = ParseResult.OK;
    if (!baseText) {
      return { value: '', result };
    }
    const { separators } = this.getValidateParams(params);
    const seps = `[${separators}]`;
    const regex = new RegExp(
      `^(?:(?:(?:(?:\\+|00)(?<landsnummer>[1-9]\\d)(?:\\(0\\))?)|0)(?<riktnummer>${allPrefixesRegex}))?(?:${seps})?(?<nummer>[1-9]\\d{4,11})$`
    );
    const match = text.match(regex);
    if (match?.groups) {
      const landsnummer = match.groups['landsnummer'];
      const riktnummer = match.groups['riktnummer'];
      const nummer = match.groups['nummer'];
      if (allowForeign || !landsnummer) {
        if (landsnummer && riktnummer && nummer) {
          value = `+${landsnummer}${riktnummer}-${nummer}`;
        } else if (riktnummer && nummer) {
          value = `0${riktnummer}-${nummer}`;
        } else if (nummer) {
          value = nummer;
        }
      } else {
        result = ParseResult.ERROR;
      }
    } else if (allowForeign) {
      value = baseText;
    } else {
      result = ParseResult.ERROR;
    }

    return { result, value };
  }
}

export { TEDParseTelNr };
